import { CHANGE_VERSION_AUTH } from './actions';

const INIT_STATE = {
	auth_state: false,
	site_general_profile: false,
	site_product_group: false,
	site_device_printer: false,
	site_user_account: false,
	site_product_category: false,
	site_product_overview: false,
	site_product_table_set_overview: false,
	site_device_machine: false,
	site_product_option_set: false,
};
const versionAuth = (state = INIT_STATE, action) => {
	const { type, payload } = action;
	switch (type) {
		case CHANGE_VERSION_AUTH:
			return { ...state, ...payload };
		default:
			return {
				...state,
			};
	}
};
export default versionAuth;
